<div class="ng-autocomplete w-100">  
    <ng-autocomplete 
      #searchInput
      [class]='classSearch'
      [data]="data"
      [searchKeyword]="keyword"
      placeholder="Buscar reserva por código o responsable"
      (selected)='selectSearch($event)'
      (inputChanged)='debouncedSearchInput($event)' 
      (inputCleared)='clearedInputSearch()'                              
      (closed)='closedSearchPanel()'                              
      [itemTemplate]="itemTemplate"
      [notFoundTemplate]="notFoundTemplate">                                 
    </ng-autocomplete>
    <ng-template #itemTemplate let-item>
      <a style="padding: 8px 15px 5px;" class="f-s-12 p-10">
        <span [innerHTML]="item.client_data.fullname"></span>  
        - DOC: <span [innerHTML]="item.client_data.document"></span> 
      </a>
      <p style="padding: 0px 20px 5px; font-size: 11px !important; margin-bottom: 4px; margin-top: -5x;">
        <span class="bold"><i class="fas fa-info-circle m-r-5"></i>CÓDIGO:</span>
        <span class="m-l-5" [innerHTML]="item.code"></span>
      </p>
    </ng-template>   
    <ng-template #notFoundTemplate let-notFound>
      <p style="padding-top: 5px;
      margin-bottom: 5px;
      font-weight: 500;" *ngIf="isTypedSearch">No se encontraron registros</p>
    </ng-template>
</div>
